import React, { ReactNode, Dispatch, SetStateAction, createContext, useState } from 'react';

import { retrievePersistentData } from '@smart-tv/utils/persistent-data/persistent-data';

export interface LoginContextProps {
  children: ReactNode | ReactNode[];
}

export interface LoginContextValues {
  email: string;
  setEmail: Dispatch<SetStateAction<string>>;
}

export const LoginContext = createContext<LoginContextValues>({} as LoginContextValues);

export const LoginConsumer = LoginContext.Consumer;

export const LoginProvider = (props: LoginContextProps): JSX.Element => {
  const { children } = props;

  const lastLoginEmail = retrievePersistentData<string>('last-login-email');

  const [email, setEmail] = useState(lastLoginEmail || '');

  return <LoginContext.Provider value={{ email, setEmail }}>{children}</LoginContext.Provider>;
};

export default LoginContext;
